<!-- Loading Indicator -->
@if (filterLoading) {
  <div class="filter-loading-overlay">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
  </div>
}

<!-- ClickUp-style View Toggle Bar -->
<div class="clickup-view-container">
  <div class="view-toolbar">
    <div class="view-tabs">
      <button class="view-tab"
        [class.active]="viewMode === ViewMode.LIST"
        (click)="onViewModeChange(ViewMode.LIST)">
        <i class="pi pi-list"></i>
        <span>List</span>
      </button>
      <button class="view-tab"
        [class.active]="viewMode === ViewMode.BOARD"
        (click)="onViewModeChange(ViewMode.BOARD)">
        <i class="pi pi-th-large"></i>
        <span>Board</span>
      </button>
      <button class="view-tab"
        [class.active]="viewMode === ViewMode.CALENDAR"
        (click)="onViewModeChange(ViewMode.CALENDAR)">
        <i class="pi pi-calendar"></i>
        <span>Calendar</span>
      </button>
      <button class="view-tab"
        [class.active]="viewMode === ViewMode.GANTT"
        (click)="onViewModeChange(ViewMode.GANTT)">
        <i class="pi pi-chart-line"></i>
        <span>Gantt</span>
      </button>
      <!-- <button class="view-tab"
      [class.active]="viewMode === ViewMode.TABLE"
      (click)="onViewModeChange(ViewMode.TABLE)">
      <i class="pi pi-table"></i>
      <span>Table</span>
    </button> -->
  </div>

  <app-task-view-controls
    [currentGroupBy]="groupBy"
    [currentFilters]="filters"
    [currentColumns]="columns"
    (groupByChange)="onGroupByChange($event)"
    (filtersChange)="onFiltersChange($event)"
    (columnsChange)="onColumnsChange($event)">
  </app-task-view-controls>

  <!-- GroupBy Dropdown for Board View -->
  @if (viewMode === ViewMode.BOARD) {
    <div class="control-dropdown">
      <select class="control-btn groupby-select"
        [value]="groupBy === 'none' ? 'status' : groupBy"
        (change)="onGroupByChange($any($event.target).value)">
        @for (option of boardGroupByOptions; track option) {
          <option [value]="option.value">
            {{ option.label }}
          </option>
        }
      </select>
    </div>
  }
</div>
</div>

<div class="grid">
  <div class="col-12 md:col-2">
    <!-- <div class="mt-2">
    <label class="fs-6 mb-1 fw-normal">People :</label>
    <div class="mt-1">
      <p-multiSelect [options]="usersSearch" [(ngModel)]="selectedUsers" [displaySelectedLabel]="true" [showClear]="true"
        optionLabel="fullName" dropdownIcon="fa fa-caret-down"
        optionValue="userId" appendTo="body"
      (onChange)="onPeopleFilterChange($event.value)"></p-multiSelect>
    </div>
  </div> -->

  <div class="mt-2">
    <label class="fs-6 mt-2 mb-1 fw-normal">Categories :</label>
    <div class="mt-1">
      <app-task-folder-nav [users]="usersSearch" (eventTagSelect)="onTagSelect($event)" (eventPeopleSelect)="onPeopleSelectFromNav($event)"></app-task-folder-nav>
    </div>
  </div>
</div>
<div class="col-12 md:col-10">
  <!-- Analytics Section -->
  <div class="d-flex flex-column flex-md-row justify-content-between">
    <div class="bg-light-blue mb-3 p-2 me-2 w-100">
      <div class="table-responsive">
        <table class="table table-bordered table-sm analytics-table summary-analytics-table mb-0">
          <thead class="table-light">
            <tr>
              <!-- <th></th> -->
              @for (col of summaryColumns; track col) {
                <th scope="col" class="text-center text-dark fw-bold">{{ col.header }}</th>
              }
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->
          @for (rowIndex of summaryRowIndexes; track rowIndex) {
            <tr>
              @for (col of summaryColumns; track col) {
                <td class="text-center">
                  @if (isSummaryLinkAvailable(col.rows[rowIndex].keys)) {
                    <div class="analytics-cell clickable summary-clickable-cell" (click)="loadWithParam(col.rows[rowIndex].param)">
                      <div class="analytics-number link-primary text-decoration-underline">
                        {{ col.rows[rowIndex].label }} = {{ getSummaryValue(col.rows[rowIndex].keys) }}
                      </div>
                    </div>
                  } @else {
                    <div class="analytics-cell summary-na-cell">
                      <div class="analytics-number text-muted">{{ col.rows[rowIndex].label }} = NA</div>
                    </div>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div>
    <div class="d-flex justify-content-end mb-1">
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;text-wrap: nowrap !important;" (click)="addTask(1)">New Task
      +</button>
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-left:10px;text-wrap: nowrap !important;"
        (click)="addQuickTask(1)">Quick
      Add</button>
      <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important; margin-left:10px;text-wrap: nowrap !important;"
        (click)="openCreateFromTemplate()"><i class="pi pi-copy" style="margin-right:5px"></i>From Template</button>
      </div>
      <div style="padding: 5px;">
        <span class="link-primary text-decoration-underline fs-12px cursor-pointer"
          (click)="reloadSummaryCount()"
          [class.disabled]="summaryLoading"
          [style.pointer-events]="summaryLoading ? 'none' : 'auto'">
          @if (summaryLoading) {
            <i class="pi pi-spin pi-spinner" style="margin-right: 5px;"></i>
          }
          @if (!summaryLoading) {
            <span>Refresh Summary</span>
          }
          @if (summaryLoading) {
            <span>Refreshing...</span>
          }
        </span>
      </div>
    </div>
  </div>

  @if (activeFilterChips.length > 0) {
    <div class="align-items-center m-2 active-filters-row">
      <div>
        <div class="d-flex align-items-center flex-wrap gap-2">
          <label class="mb-0 me-2" style="font-weight: 600;">Active Filters ({{activeFilterChips?.length}}) : </label>
          @for (chip of activeFilterChips; track trackByChipKey($index, chip)) {
            <button type="button"
              class="active-filter-chip"
              (click)="removeFilterChip(chip.key, $event)">
              <span [innerHTML]="chip.display"></span>
              <i class="pi pi-times ms-2" aria-hidden="true"></i>
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- List View -->
  <!-- <app-task-list
  *ngIf="viewMode === ViewMode.LIST"
  #taskListComponent
  [taskTag]="selectedTag"
  [showFilter]="true"
  [showPagination]="true"
  [outlineNewButton]="true"
  [groupBy]="groupBy"
  [columns]="columns"
  [viewControlsFilters]="filters"
  (tasksLoaded)="onTasksLoaded($event)"
(filtersChanged)="onListFiltersChanged($event)"></app-task-list> -->

<!-- Board View -->
@if (viewMode === ViewMode.BOARD) {
  <app-task-board-view
    #taskBoardComponent
    [tasks]="tasks"
    [taskTag]="selectedTag"
    [groupBy]="groupBy"
    [filters]="filters"
    (taskClick)="onTaskClick($event)"
    (taskDoubleClick)="onTaskDoubleClick($event)"
    (taskCreated)="onTaskCreated()"
  (filtersProcessed)="onFiltersProcessed()"></app-task-board-view>
}

<!-- Calendar View -->
@if (viewMode === ViewMode.CALENDAR) {
  <app-task-calendar-view
    #taskCalendarComponent
    [tasks]="tasks"
    [taskTag]="selectedTag"
    [groupBy]="groupBy"
    [filters]="filters"
    (taskClick)="onTaskClick($event)"
    (taskDoubleClick)="onTaskDoubleClick($event)"
    (filtersProcessed)="onFiltersProcessed()"
  (analyticsUpdate)="onCalendarAnalyticsUpdate($event)"></app-task-calendar-view>
}

<!-- Gantt View -->
@if (viewMode === ViewMode.GANTT) {
  <app-task-gantt-view
    #taskGanttComponent
    [tasks]="tasks"
    [taskTag]="selectedTag"
    [groupBy]="groupBy"
    [filters]="filters"
    (taskClick)="onTaskClick($event)"
    (taskDoubleClick)="onTaskDoubleClick($event)"
  (filtersProcessed)="onFiltersProcessed()"></app-task-gantt-view>
}

<!-- Table View -->
@if (viewMode === ViewMode.TABLE || viewMode === ViewMode.LIST) {
  <app-task-table-view
    #taskTableComponent
    [tasks]="tasks"
    [taskTag]="selectedTag"
    [groupBy]="groupBy"
    [columns]="columns"
    [filters]="filters"
    (taskClick)="onTaskClick($event)"
    (taskDoubleClick)="onTaskDoubleClick($event)"
  (filtersProcessed)="onFiltersProcessed()"></app-task-table-view>
}
</div>
</div>

<!-- Create from Template Dialog -->
<p-dialog header="Create from Template" [(visible)]="showTemplateDialog" [modal]="true" [style]="{width: '550px'}" [closable]="true">
  <div class="p-fluid">
    <div class="field mb-3">
      <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Select Template</label>
      <p-dropdown [options]="templateList" [(ngModel)]="selectedTemplateId" optionLabel="name" optionValue="taskId"
        placeholder="Choose a template..." [filter]="true" filterBy="name" [showClear]="true"
      (onChange)="onTemplateSelected($event.value)" [style]="{'width':'100%'}"></p-dropdown>
    </div>

    @if (templateChildren.length > 0) {
      <div class="field mb-3">
        <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Subtasks ({{templateChildren.length}})</label>
        <div style="max-height: 150px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px; padding: 8px;">
          @for (child of templateChildren; track child) {
            <div style="padding: 4px 0; font-size: 13px; border-bottom: 1px solid #f0f0f0;">
              <i class="pi pi-chevron-right" style="font-size: 10px; margin-right: 6px; color: #999;"></i>{{child.name}}
            </div>
          }
        </div>
      </div>
    }

    <div class="field mb-3">
      <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Name (optional override)</label>
      <input pInputText type="text" [(ngModel)]="templateOverrides.name" placeholder="Leave blank to use template name">
    </div>

    <div class="field mb-3">
      <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Due Date</label>
      <p-calendar [(ngModel)]="templateOverrides.dateDue" dateFormat="mm/dd/yy" [showIcon]="true" placeholder="Select due date"></p-calendar>
    </div>

    <div class="field mb-3">
      <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Unit Code (str_1)</label>
      <input pInputText type="text" [(ngModel)]="templateOverrides.str_1" placeholder="e.g. WH2-465">
    </div>

    <div class="field mb-3">
      <label style="font-size: 12px; color: #666; margin-bottom: 4px; display: block;">Reference (str_2)</label>
      <input pInputText type="text" [(ngModel)]="templateOverrides.str_2" placeholder="e.g. reference property code">
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple class="p-button-text" label="Cancel" (click)="showTemplateDialog = false"></button>
    <button pButton pRipple label="Create" icon="pi pi-check" (click)="createFromTemplate()"
    [disabled]="!selectedTemplateId || templateInstantiating" [loading]="templateInstantiating"></button>
  </ng-template>
</p-dialog>
